import { Heading } from 'grommet'
import styled, { css } from 'styled-components'

export const Title = styled(Heading)`
  text-transform: capitalize;
  width: 100%;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title2')}
    `}
  `}
`
